import { render, staticRenderFns } from "./EditPageUser.vue?vue&type=template&id=2c236d83"
import script from "./EditPageUser.vue?vue&type=script&lang=js"
export * from "./EditPageUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports